import styled, { css } from "styled-components";
import { commafySymbol } from "../../utils/commafy";

const StyledCurrency = styled.span<{ india?: boolean }>`
	font-size: inherit !important;
	line-height: inherit !important;
	${(p) =>
		p.india &&
		css`
			vertical-align: middle;
		`};
`;

const Currency = (props: { countryIso?: string; amount: number }) => {
	const normalizedIso = props.countryIso?.toUpperCase();

	const isIndia = normalizedIso === "IN" || normalizedIso === "IND";

	return (
		<>
			<StyledCurrency india={isIndia} className={props.countryIso}>
				{commafySymbol(props.countryIso)}
			</StyledCurrency>
			{!props.amount
				? "0"
				: props.amount.toLocaleString(isIndia ? "en-IN" : "en-US", {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})}
		</>
	);
};

export default Currency;
